
new Swiper('.buly-gallery-carousel', {
  slidesPerView: 1,
  loop: true,

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

if (document.querySelector('.variant-slider')) {
  new Swiper('.variant-slider', {
    spaceBetween: 15,
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    }
  })
}

if (document.querySelector('.value-slider-carousel')) {
  new Swiper('.value-slider-carousel', {
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
  });
}


if (document.querySelector('.recipe-bundle-carousel')) {
  new Swiper('.recipe-bundle-carousel', {
    slidesPerView: 2.25,
    spaceBetween: 15,
    watchSlidesProgress: true,
    breakpoints: {
      750: {
        slidesPerView: 3.5,
        spaceBetween: 30
      }
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    }
  })
}


let pdpSplitCarousel = false;
if (document.querySelector('.pdp-split-banner')) {
  checkWidthPdpSplit();
}

function checkWidthPdpSplit() {
  if (window.matchMedia("(min-width: 990px)").matches) {
    if (pdpSplitCarousel) {
      destroyPdpSplitCar();
    }
  } else {
    if (!pdpSplitCarousel) {
      buildPdpSplitCar();
    }
  }
}

function buildPdpSplitCar() {
  new Swiper('.pdp-split-banner', {
    slidesPerView: 1.025,
    spaceBetween: 15,
    watchSlidesProgress: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
  });
  pdpSplitCarousel = true;
}

function destroyPdpSplitCar() {
  const pdpSplitCar = document.querySelector('.pdp-split-banner').swiper;
  pdpSplitCar.destroy();
  pdpSplitCarousel = false;
}

window.addEventListener("resize", function () {
  checkWidthPdpSplit();
});


class pdpEnlarger extends HTMLElement {
  constructor() {
    super();
    this.imageSlides = this.querySelectorAll('.buly-card-product__image');
    this.closeBtn = this.querySelector('.product-media-modal__toggle');
    this.modal = this.querySelector('product-modal');

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closeEnlarge.bind(this));
    }

    this.imageSlides.forEach(
      (slide) => {
        slide.addEventListener('click', this.openEnlarge.bind(this));
      }
    );
  }

  openEnlarge(e) {
    this.modal.style.visibility = 'visible';
    this.modal.style.opacity = '1';
    this.modal.style.zIndex = '101';
  }

  closeEnlarge(e) {
    this.modal.style.visibility = 'hidden';
    this.modal.style.opacity = '0';
    this.modal.style.zIndex = '-1';
  }

}
customElements.define('pdp-gallery', pdpEnlarger);


class returnToTop extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('button');
    this.btn.addEventListener('click', this.moveBackUp.bind(this));
  }

  moveBackUp() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
  });
  }
}
customElements.define('pdp-return-top', returnToTop);
